import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice } from '@grandvisionhq/utils';

const Price = (_param)=>{
    var { value , centAmount =true , currency , className , type ='default' , size ='custom' , 'aria-label': ariaLabel , fixedDecimals , prefix  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "value",
        "centAmount",
        "currency",
        "className",
        "type",
        "size",
        'aria-label',
        "fixedDecimals",
        "prefix"
    ]);
    const { locale  } = useIntl();
    const Component = type === 'strikethrough' ? 's' : 'span';
    const formattedPrice = formatPrice({
        locale,
        value,
        currency,
        isCentAmount: !!centAmount,
        fixedDecimals
    });
    const priceLabel = `${prefix ? `${prefix} ` : ''}${formattedPrice}`;
    return /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, rest, {
        className: classnames('price', `price--${type}`, `price--${size}`, className)
    }), ariaLabel && /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, ariaLabel, "\xa0"), priceLabel);
};

export { Price as default };
//# sourceMappingURL=Price.js.map
